module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp23_0.b201566e.png";